import script from "./LanguageSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageSelect.vue?vue&type=script&setup=true&lang=js"

import "./LanguageSelect.vue?vue&type=style&index=0&id=1300c332&scoped=true&lang=css"
import "./LanguageSelect.vue?vue&type=style&index=1&id=1300c332&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1300c332"]])

export default __exports__